import { createFileRoute } from '@tanstack/react-router';
import { JournalsPage } from '@/features/accounting/parameters/journals/components/JournalsPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/parameters/journals/{-$id}')({
  component: RouteComponent,
});

function RouteComponent() {
  return <JournalsPage />;
}
